<template>
  <div :id="`item-${objectID}`" class="result" @mouseup="openViewer(result)">
    <img
        :src="thumbnail"
        :alt="caption"
        class="thumb"
        @contextmenu.prevent @drag.prevent @dragstart.prevent
    >

    <button type="button" class="cta" title="Open Photo">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           v-if="result.__type === 'gallery'">
        <path
            d="M10 15c0-.552.448-1 1.001-1s.999.448.999 1-.446 1-.999 1-1.001-.448-1.001-1zm6.2 0l-1.7 2.6-1.3-1.6-3.2 4h10l-3.8-5zm7.8-5v14h-18v-14h18zm-2 2h-14v10h14v-10zm-6.462-9.385l2.244 5.385h2.167l-3.334-8-16.615 6.923 4 9.663v-5.265l-1.384-3.321 12.922-5.385z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           v-else-if="result.__type === 'video'">
        <path
            d="M13 2.004c5.046.504 9 4.783 9 9.97 0 1.467-.324 2.856-.892 4.113l1.738 1.005c.732-1.553 1.154-3.284 1.154-5.117 0-6.304-4.842-11.464-11-11.975v2.004zm-10.109 14.083c-.568-1.257-.891-2.646-.891-4.112 0-5.188 3.954-9.466 9-9.97v-2.005c-6.158.511-11 5.671-11 11.975 0 1.833.421 3.563 1.153 5.118l1.738-1.006zm17.213 1.734c-1.817 2.523-4.769 4.174-8.104 4.174s-6.288-1.651-8.105-4.175l-1.746 1.01c2.167 3.123 5.768 5.17 9.851 5.17 4.082 0 7.683-2.047 9.851-5.168l-1.747-1.011zm-8.104-13.863c-4.419 0-8 3.589-8 8.017s3.581 8.017 8 8.017 8-3.589 8-8.017-3.581-8.017-8-8.017zm-2 11.023v-6.013l6 3.152-6 2.861z"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-else>
        <path
            d="M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 3c-2.21 0-4 1.791-4 4s1.79 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zm-.004 3.999c-.564.564-1.479.564-2.044 0s-.565-1.48 0-2.044c.564-.564 1.479-.564 2.044 0s.565 1.479 0 2.044z"/>
      </svg>
    </button>
  </div>
</template>

<script>

export default {
  name: "mediaThumb",

  props: {
    result: Object,
    objectID: Number | String,
    thumbnail: String,
    caption: {
      type: String,
      default: ''
    },
  },

  data() {
    return {};
  },

  methods: {
    openViewer(result) {
      this.$emit('openViewer', result);
    }
  }
}
</script>

<style lang="scss" scoped>

.result {
  margin-bottom: var(--mgt-results-gap);
  position: relative;
  cursor: pointer;

  &:active .thumb {
    transform: scale(0.9);
  }
}

.thumb {
  display: block;
  object-fit: cover;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-in-out;
}


.cta {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: none;
  border: 0;
  line-height: 1;
  width: 30%;
  color: var(--mgt-cta-color);
  transition: all 0.3s ease-in-out;
  cursor: pointer;


  svg {
    fill: currentColor;
    width: 100%;
    height: auto;
    transition: all 0.3s ease-in-out;
    opacity: .5;
  }
}

.result:hover .cta {
  color: var(--mgt-cta-hover-color);

  svg {
    transform: scale(1.2);
    opacity: 1;
  }
}
</style>